import React from "react";
import SkeletonPlaceHolder from 'gui/components/skeletonPlaceHolder';
import styles from './GenericLoadingIconButton.module.scss';
import {Button} from '@material-ui/core';

export interface IGenericLoadingIconButtonProps {
  onClick?: any;
  loading?: boolean;
  icon: any;
}

const GenericLoadingIconButton = (props: IGenericLoadingIconButtonProps) => {
  return props.loading ?
    <Button>
      <SkeletonPlaceHolder className={styles.loading}/>
    </Button>
    :
    <Button onClick={props.onClick}>
      <props.icon/>
    </Button>;
};

GenericLoadingIconButton.defaultProps = {};

export default React.memo(GenericLoadingIconButton);
